<div class="action-buttons">

  <app-simulation-coverage-area *ngIf="coverageMode$ | async else buttonBlock"></app-simulation-coverage-area>

  <ng-template #buttonBlock>

    <button mat-button class="app-block" (click)="editCoverageArea()">
      <mat-icon *ngIf="stepsStatus.coverage">
        check_circle
      </mat-icon>
      <span i18n>COVERAGE AREAS</span>
    </button>

    <button mat-button class="app-block" [disabled]="!stepsStatus.coverage" (click)="openTopology()">
      <mat-icon *ngIf="stepsStatus.topology">
        check_circle
      </mat-icon>
      <span i18n>TOPOLOGY</span>
    </button>

    <button mat-button class="app-block" [disabled]="!stepsStatus.topology" (click)="openArchitecture()">
      <mat-icon *ngIf="stepsStatus.architeture">
        check_circle
      </mat-icon>
      <span i18n>ARCHITECTURE</span>
    </button>

    <button mat-button class="app-block" (click)="openAttenuation()" [disabled]="!stepsStatus.architeture">
      <mat-icon *ngIf="stepsStatus.attenuation">
        check_circle
      </mat-icon>
      <span i18n>ATTENUATION</span>
    </button>

    <button mat-button class="app-block" (click)="openMaterials()" [disabled]="!stepsStatus.architeture">
      <mat-icon *ngIf="stepsStatus.materials">
        check_circle
      </mat-icon>
      <span i18n>MATERIALS</span>
    </button>

    <button mat-button class="app-block" *ngIf="!production && (parametersErrors$ | async)?.length"
      (click)="debugParameters()">
      <mat-error>
        <mat-icon>error</mat-icon>
      </mat-error>
      DEBUG ERRORS
    </button>

    <button mat-button class="app-block" [disabled]="!stepsStatus.materials || !stepsStatus.attenuation"
      (click)="validate()">

      <mat-icon *ngIf="stepsStatus.validation">
        check_circle
      </mat-icon>
      <span i18n>VALIDATION</span>
    </button>

  </ng-template>

</div>
